import * as types from 'store/modules/hrms15e/mutation-types'
import hrms15e from 'api/hrms15e'
import swal from 'sweetalert'
import hrms15eLabels from 'assets/labels/hrms15e'
import { hrms15eMaxRowspan, hrms15eColumns } from 'assets/columns/hrms15e'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'
import axios from 'axios'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hrms15eLabels,
    maxRowspan: hrms15eMaxRowspan,
    columns: hrms15eColumns(),
    index: {
      total: 0,
      rows: []
    },
    indexSelected: {},
    detail3Selected: {},
    detailDisabled: false,
    detailDisabled1: false,
    detailDisabled2: false,
    detailDisabled3: false,
    detail1Disp: true,
    detail1Desc1Disp: false,
    detail3Desc1Disp: false,
    detail3Desc2Disp: false,
    detail3Desc3Disabled: false,
    detail3Disp: true,
    detail3Desc3Disp: false,
    detail3InfoDisp: false,
    detail3InfoIndexSelected: 0,
    detail3InfoDesc1Disp: false,
    detail3InfoLeftDisp: false,
    detail3InfoDesc1CourseDisp: false,
    showDetailDescDisp: false,
    flgDisabled: true,
    detail: {
      tab1: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab2: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab3: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      }
    },
    detailTab1Desc2: {
      total: 0,
      rows: []
    },
    detailTab2Desc2: {
      total: 0,
      rows: []
    },
    detailTab3Desc1: {
      total: 0,
      rows: []
    },
    detailTab3Desc2: {
      detail: {},
      table: {
        total: 0,
        rows: []
      }
    },
    detailTab3Desc3: {
      total: 0,
      rows: []
    },
    detail3Info: {
      total: 0,
      rows: []
    },
    detailCourse: {
      total: 0,
      rows: []
    },
    popupCourseGap: {
      total: 0,
      rows: []
    },
    popupDetail3InfoDesc1: {
      total: 0,
      rows: []
    },
    popupDetail3InfoDesc2: {
      detail: {},
      table: {
        total: 0,
        rows: []
      }
    },
    inlineDetail3Info: {},
    dropdowns: {
      statuskpi: {
        en: {},
        th: {}
      },
      flgdqtysc: {
        en: {},
        th: {}
      }
    },
    sendmail: {},
    detailTab1Desc2Selected: {},
    detailTab2Desc2Selected: {},
    detailTab3Desc1Selected: {},
    detailTab3Desc3Selected: {},
    detailTab1Desc2IndexSelected: 0,
    detailTab2Desc2IndexSelected: 0,
    detailTab3Desc3IndexSelected: 0,
    detail3InfoSelected: {
      kpino: '',
      kpiitem: '',
      target: '',
      achieve: '',
      v_mtrunit: '',
      mtrvalue: '',
      v_mtrvalue: '',
      status: '',
      dtetargt: '',
      kpiwgt: '',
      grdscor: '',
      table: []
    },
    sumscore: {},
    flgProcess: true
  },
  getters: {
    [types.GET_HRMS15E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS15E_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRMS15E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS15E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS15E_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRMS15E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS15E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS15E_DETAIL3_SELECTED] (state) {
      return state.detail3Selected
    },
    [types.GET_HRMS15E_DROPDOWNS] (state) {
      return state.dropdowns
    },
    [types.GET_HRMS15E_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRMS15E_DETAIL1_DESC2] (state) {
      return state.detailTab1Desc2
    },
    [types.GET_HRMS15E_DETAIL2_DESC2] (state) {
      return state.detailTab2Desc2
    },
    [types.GET_HRMS15E_DETAIL3_DESC1] (state) {
      return state.detailTab3Desc1
    },
    [types.GET_HRMS15E_DETAIL3_DESC2] (state) {
      return state.detailTab3Desc2
    },
    [types.GET_HRMS15E_DETAIL3_DESC3] (state) {
      return state.detailTab3Desc3
    },
    [types.GET_HRMS15E_DETAIL3_INFO] (state) {
      return state.detail3Info
    },
    [types.GET_HRMS15E_DETAIL_COURSE] (state) {
      return state.detailCourse
    },
    [types.GET_HRMS15E_DETAIL_DISABLED] (state) {
      return state.detailDisabled
    },
    [types.GET_HRMS15E_DETAIL_DISABLED1] (state) {
      return state.detailDisabled1
    },
    [types.GET_HRMS15E_DETAIL_DISABLED2] (state) {
      return state.detailDisabled2
    },
    [types.GET_HRMS15E_DETAIL_DISABLED3] (state) {
      return state.detailDisabled3
    },
    [types.GET_HRMS15E_COURSE_GAP_POPUP] (state) {
      return state.popupCourseGap
    },
    [types.GET_HRMS15E_DETAIL3_DESC1_DISP] (state) {
      return state.detail3Desc1Disp
    },
    [types.GET_HRMS15E_DETAIL3_DESC2_DISP] (state) {
      return state.detail3Desc2Disp
    },
    [types.GET_HRMS15E_DETAIL3_DESC3_DISABLED] (state) {
      return state.detail3Desc3Disabled
    },
    [types.GET_HRMS15E_DETAIL3_DISP] (state) {
      return state.detail3Disp
    },
    [types.GET_HRMS15E_DETAIL3_DESC3_DISP] (state) {
      return state.detail3Desc3Disp
    },
    [types.GET_HRMS15E_DETAIL3_INFO_INLINE] (state) {
      return state.inlineDetail3Info
    },
    [types.GET_HRMS15E_DETAIL3_INFO_DISP] (state) {
      return state.detail3InfoDisp
    },
    [types.GET_HRMS15E_DETAIL3_INFO_LEFT_DISP] (state) {
      return state.detail3InfoLeftDisp
    },
    [types.GET_HRMS15E_DETAIL3_INFO_DESC1_DISP] (state) {
      return state.detail3InfoDesc1Disp
    },
    [types.GET_HRMS15E_DETAIL3_INFO_DESC1_COURSE_DISP] (state) {
      return state.detail3InfoDesc1CourseDisp
    },
    [types.GET_HRMS15E_DETAIL3_INFO_DESC2_POPUP] (state) {
      return state.popupDetail3InfoDesc2
    },
    [types.GET_HRMS15E_DETAIL1_DESC2_SELECTED] (state) {
      return state.detailTab1Desc2Selected
    },
    [types.GET_HRMS15E_DETAIL2_DESC2_SELECTED] (state) {
      return state.detailTab2Desc2Selected
    },
    [types.GET_HRMS15E_DETAIL3_DESC1_SELECTED] (state) {
      return state.detailTab3Desc1Selected
    },
    [types.GET_HRMS15E_DETAIL3_DESC3_INDEX_SELECTED] (state) {
      return state.detailTab3Desc3IndexSelected
    },
    [types.GET_HRMS15E_DETAIL3_DESC3_SELECTED] (state) {
      return state.detailTab3Desc3Selected
    },
    [types.GET_HRMS15E_DETAIL3_INFO_SELECTED] (state) {
      return state.detail3InfoSelected
    },
    [types.GET_HRMS15E_SHOW_DETAIL_DESC_DISP] (state) {
      return state.showDetailDescDisp
    },
    [types.GET_HRMS15E_DETAIL1_DISP] (state) {
      return state.detail1Disp
    },
    [types.GET_HRMS15E_DETAIL1_DESC1_DISP] (state) {
      return state.detail1Desc1Disp
    },
    [types.GET_HRMS15E_FLG_DISABLED] (state) {
      return state.flgDisabled
    },
    [types.GET_HRMS15E_DETAIL3_INFO_INDEX_SELECTED] (state) {
      return state.detail3InfoIndexSelected
    },
    [types.GET_HRMS15E_SUMSCORE] (state) {
      return state.sumscore
    },
    [types.GET_HRMS15E_DETAIL1_DESC2_INDEX_SELECTED] (state) {
      return state.detailTab1Desc2IndexSelected
    },
    [types.GET_HRMS15E_DETAIL2_DESC2_INDEX_SELECTED] (state) {
      return state.detailTab2Desc2IndexSelected
    },
    [types.GET_HRMS15E_FLG_PROCESS] (state) {
      return state.flgProcess
    }
  },
  mutations: {
    [types.SET_HRMS15E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS15E_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRMS15E_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detail1Desc1Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail1Desc1Table, labels[keyLang])
        state.columns[keyLang].detail2Desc1Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail2Desc1Table, labels[keyLang])
        state.columns[keyLang].courseGapPopupTable = configLabel.replaceLabelToColumns(state.columns[keyLang].courseGapPopupTable, labels[keyLang])
        state.columns[keyLang].detail3Desc2Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail3Desc2Table, labels[keyLang])
        state.columns[keyLang].detail3Desc3Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail3Desc3Table, labels[keyLang])
        state.columns[keyLang].detail3InfoTable = configLabel.replaceLabelToColumns(state.columns[keyLang].detail3InfoTable, labels[keyLang])
        state.columns[keyLang].detail3InfoDesc1Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail3InfoDesc1Table, labels[keyLang])
        state.columns[keyLang].detail3InfoDesc2PopupTable = configLabel.replaceLabelToColumns(state.columns[keyLang].detail3InfoDesc2PopupTable, labels[keyLang])
      }
    },
    [types.SET_HRMS15E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRMS15E_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS15E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS15E_DETAIL3_SELECTED] (state, detail3Selected) {
      state.detail3Selected = detail3Selected
    },
    [types.SET_HRMS15E_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    },
    [types.SET_HRMS15E_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRMS15E_DETAIL1_DESC2] (state, data) {
      state.detailTab1Desc2 = data
    },
    [types.SET_HRMS15E_DETAIL2_DESC2] (state, data) {
      state.detailTab2Desc2 = data
    },
    [types.SET_HRMS15E_DETAIL3_DESC1] (state, data) {
      state.detailTab3Desc1 = data
    },
    [types.SET_HRMS15E_DETAIL3_DESC2] (state, data) {
      state.detailTab3Desc2 = data
    },
    [types.SET_HRMS15E_DETAIL3_DESC3] (state, data) {
      state.detailTab3Desc3 = data
    },
    [types.SET_HRMS15E_DETAIL3_INFO] (state, data) {
      state.detail3Info = data
    },
    [types.SET_HRMS15E_DETAIL_COURSE] (state, data) {
      state.detailCourse = data
    },
    [types.SET_HRMS15E_DETAIL_DISABLED] (state, detailDisabled) {
      state.detailDisabled = detailDisabled
    },
    [types.SET_HRMS15E_DETAIL_DISABLED1] (state, detailDisabled1) {
      state.detailDisabled1 = detailDisabled1
    },
    [types.SET_HRMS15E_DETAIL_DISABLED2] (state, detailDisabled2) {
      state.detailDisabled2 = detailDisabled2
    },
    [types.SET_HRMS15E_DETAIL_DISABLED3] (state, detailDisabled3) {
      state.detailDisabled3 = detailDisabled3
    },
    [types.SET_HRMS15E_DETAIL_COURSE_ADD_INLINE_FROM_GAP] (state, dataRows) {
      for (var row = 1; row <= dataRows.length; row++) {
        let dataRow = dataRows[row - 1]
        let duplicateDataRow = state.detailCourse.rows.filter(function (stateDataRow) {
          return stateDataRow.codcours === dataRow.codcours
        })
        if (duplicateDataRow.length === 0) {
          dataRow['flgAdd'] = true
          state.detailCourse.rows.push(dataRow)
          state.detailCourse.total = state.detailCourse.rows.length
        }
      }
    },
    [types.SET_HRMS15E_DETAIL_COURSE_ADD_INLINE] (state, { data, param }) {
      let rowIndex = state.detailCourse.rows.map(function (dataRow) {
        return dataRow.codcours
      }).indexOf(param.codcours)
      state.detailCourse.rows[rowIndex].codcours = data.codcours
      state.detailCourse.rows[rowIndex].desc_codcours = data.desc_codcours
      state.detailCourse.rows[rowIndex].desc_codcate = data.desc_codcate
      state.detailCourse.rows[rowIndex].desc_typtrain = data.desc_typtrain
      state.detailCourse.rows[rowIndex].qtyppc = data.qtyppc
    },
    [types.SET_HRMS15E_COURSE_GAP_POPUP] (state, popupCourseGap) {
      state.popupCourseGap = popupCourseGap
    },
    [types.SET_HRMS15E_DETAIL3_DESC1_DISP] (state, detail3Desc1Disp) {
      state.detail3Desc1Disp = detail3Desc1Disp
    },
    [types.SET_HRMS15E_DETAIL3_DESC2_DISP] (state, detail3Desc2Disp) {
      state.detail3Desc2Disp = detail3Desc2Disp
    },
    [types.SET_HRMS15E_DETAIL3_DESC3_DISABLED] (state, detail3Desc3Disabled) {
      state.detail3Desc3Disabled = detail3Desc3Disabled
    },
    [types.SET_HRMS15E_DETAIL3_DISP] (state, detail3Disp) {
      state.detail3Disp = detail3Disp
    },
    [types.SET_HRMS15E_DETAIL3_DESC3_DISP] (state, detail3Desc3Disp) {
      state.detail3Desc3Disp = detail3Desc3Disp
    },
    [types.SET_HRMS15E_DETAIL3_INFO_INLINE] (state, inlineDetail3Info) {
      state.inlineDetail3Info = inlineDetail3Info
    },
    [types.SET_HRMS15E_DETAIL3_INFO_DISP] (state, detail3InfoDisp) {
      state.detail3InfoDisp = detail3InfoDisp
    },
    [types.SET_HRMS15E_DETAIL3_INFO_LEFT_DISP] (state, detail3InfoLeftDisp) {
      state.detail3InfoLeftDisp = detail3InfoLeftDisp
    },
    [types.SET_HRMS15E_DETAIL3_INFO_DESC1_DISP] (state, detail3InfoDesc1Disp) {
      state.detail3InfoDesc1Disp = detail3InfoDesc1Disp
    },
    [types.SET_HRMS15E_DETAIL3_INFO_DESC1_COURSE_DISP] (state, detail3InfoDesc1CourseDisp) {
      state.detail3InfoDesc1CourseDisp = detail3InfoDesc1CourseDisp
    },
    [types.SET_HRMS15E_DETAIL3_INFO_DESC2_POPUP] (state, popupDetail3InfoDesc2) {
      state.popupDetail3InfoDesc2 = popupDetail3InfoDesc2
    },
    [types.SET_HRMS15E_DETAIL1_DESC2_SELECTED] (state, detailTab1Desc2Selected) {
      state.detailTab1Desc2Selected = detailTab1Desc2Selected
    },
    [types.SET_HRMS15E_DETAIL2_DESC2_SELECTED] (state, detailTab2Desc2Selected) {
      state.detailTab2Desc2Selected = detailTab2Desc2Selected
    },
    [types.SET_HRMS15E_DETAIL3_DESC1_SELECTED] (state, detailTab3Desc1Selected) {
      state.detailTab3Desc1Selected = detailTab3Desc1Selected
    },
    [types.SET_HRMS15E_DETAIL3_DESC3_SELECTED] (state, detailTab3Desc3Selected) {
      state.detailTab3Desc3Selected = detailTab3Desc3Selected
    },
    [types.SET_HRMS15E_DETAIL3_DESC3_INDEX_SELECTED] (state, detailTab3Desc3IndexSelected) {
      state.detailTab3Desc3IndexSelected = detailTab3Desc3IndexSelected
    },
    [types.SET_HRMS15E_DETAIL3_INFO_SELECTED] (state, detail3InfoSelected) {
      state.detail3InfoSelected = detail3InfoSelected
    },
    [types.SET_HRMS15E_SHOW_DETAIL_DESC_DISP] (state, showDetailDescDisp) {
      state.showDetailDescDisp = showDetailDescDisp
    },
    [types.SET_HRMS15E_DETAIL1_DISP] (state, detail1Disp) {
      state.detail1Disp = detail1Disp
    },
    [types.SET_HRMS15E_DETAIL1_DESC1_DISP] (state, detail1Desc1Disp) {
      state.detail1Desc1Disp = detail1Desc1Disp
    },
    [types.SET_HRMS15E_FLG_DISABLED] (state, flgDisabled) {
      state.flgDisabled = flgDisabled
    },
    [types.SET_HRMS15E_DETAIL3_INFO_INDEX_SELECTED] (state, detail3InfoIndexSelected) {
      state.detail3InfoIndexSelected = detail3InfoIndexSelected
    },
    [types.SET_HRMS15E_DETAIL1_DESC2_INDEX_SELECTED] (state, detailTab1Desc2IndexSelected) {
      state.detailTab1Desc2IndexSelected = detailTab1Desc2IndexSelected
    },
    [types.SET_HRMS15E_DETAIL2_DESC2_INDEX_SELECTED] (state, detailTab2Desc2IndexSelected) {
      state.detailTab2Desc2IndexSelected = detailTab2Desc2IndexSelected
    },
    [types.SET_HRMS15E_SUMSCORE] (state, sumscore) {
      state.sumscore = sumscore
    },
    [types.SET_HRMS15E_FLG_PROCESS] (state, flgProcess) {
      state.flgProcess = flgProcess
    }
  },
  actions: {
    [types.TOGGLE_HRMS15E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRMS15E_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS15E_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRMS15E_DROPDOWNS_COLUMNS_LABELS] ({ state, commit }) {
      axios.all([
        hrms15e.getLabels(),
        hrms15e.getDropdowns()
      ])
      .then(axios.spread(function (responseColumnsLabels, responseDropdowns) {
        const dataDropdowns = JSON.parse(responseDropdowns.request.response)
        commit(types.SET_HRMS15E_DROPDOWNS, dataDropdowns)

        const dataColumnsLabels = JSON.parse(responseColumnsLabels.request.response)
        commit(types.SET_HRMS15E_COLUMNS, dataColumnsLabels.labels)
        commit(types.SET_HRMS15E_LABELS, dataColumnsLabels.labels)
      }))
      .catch((error) => {
        let message = error
        if (error.response) {
          const data = error.response.data
          message = data.response
        }
        swal({
          title: '', text: message, html: true, type: 'error'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      })
    },
    [types.RECEIVED_HRMS15E_INDEX] ({ commit }, searchParams) {
      hrms15e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS15E_INDEX, objData)
        })
    },
    [types.RECEIVED_HRMS15E_DETAIL] ({ commit }, detailParams) {
      commit(types.SET_HRMS15E_FLG_PROCESS, true)
      hrms15e.getDetail(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_DETAIL, data)
          commit(types.SET_HRMS15E_FLG_PROCESS, false)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let detail = {
            tab1: {
              detail: {},
              table: {
                total: 0,
                rows: []
              }
            },
            tab2: {
              detail: {},
              table: {
                total: 0,
                rows: []
              }
            },
            tab3: {
              detail: {},
              table: {
                total: 0,
                rows: []
              }
            }
          }
          commit(types.SET_HRMS15E_DETAIL, detail)
          commit(types.SET_HRMS15E_FLG_PROCESS, false)
        })
    },
    [types.RECEIVED_HRMS15E_DETAIL_COURSE] ({ commit }, courseParams) {
      hrms15e.getDetailCourse(courseParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_DETAIL_COURSE, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS15E_DETAIL1_DESC2] ({ commit, state }, detailParams) {
      hrms15e.getDetailTab1Desc2(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_DETAIL1_DESC2, data)
          if (data.rows.length > 0) {
            commit(types.SET_HRMS15E_DETAIL1_DESC2_SELECTED, data.rows[state.detailTab1Desc2IndexSelected])
          } else {
            commit(types.SET_HRMS15E_DETAIL1_DESC2_SELECTED, {})
          }
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          commit(types.SET_HRMS15E_DETAIL_DISABLED, false)
          commit(types.SET_HRMS15E_DETAIL_DISABLED1, false)
        })
    },
    [types.RECEIVED_HRMS15E_DETAIL_COURSE_ADD_INLINE] ({ commit }, param) {
      hrms15e.getDetailCourseAddInline(param)
        .then((response) => {
          const codcoursData = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_DETAIL_COURSE_ADD_INLINE, { data: codcoursData, param: param })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS15E_COURSE_GAP_POPUP] ({ commit }, popupParams) {
      hrms15e.getCourseGapPopup(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_COURSE_GAP_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS15E_DETAIL2_DESC2] ({ commit, state }, detailParams) {
      hrms15e.getDetailTab2Desc2(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_DETAIL2_DESC2, data)
          if (data.rows.length > 0) {
            commit(types.SET_HRMS15E_DETAIL2_DESC2_SELECTED, data.rows[state.detailTab2Desc2IndexSelected])
          } else {
            commit(types.SET_HRMS15E_DETAIL2_DESC2_SELECTED, {})
          }
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          commit(types.SET_HRMS15E_DETAIL_DISABLED, false)
          commit(types.SET_HRMS15E_DETAIL_DISABLED2, false)
        })
    },
    [types.RECEIVED_HRMS15E_DETAIL3_DESC1] ({ commit }, detailParams) {
      hrms15e.getDetailTab3Desc1(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_DETAIL3_DESC1, data)
          if (data.rows.length > 0) {
            commit(types.SET_HRMS15E_DETAIL3_DESC1_SELECTED, data.rows[0])
          } else {
            commit(types.SET_HRMS15E_DETAIL3_DESC1_SELECTED, {})
          }
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          commit(types.SET_HRMS15E_DETAIL_DISABLED, false)
          commit(types.SET_HRMS15E_DETAIL_DISABLED3, false)
          commit(types.SET_HRMS15E_DETAIL3_DESC1_DISP, false)
          commit(types.SET_HRMS15E_DETAIL3_DESC2_DISP, false)
          commit(types.SET_HRMS15E_DETAIL3_INFO_DESC1_DISP, true)
        })
    },
    [types.RECEIVED_HRMS15E_DETAIL3_DESC2] ({ commit }, detailParams) {
      hrms15e.getDetailTab3Desc2(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_DETAIL3_DESC2, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          commit(types.SET_HRMS15E_DETAIL_DISABLED, false)
          commit(types.SET_HRMS15E_DETAIL_DISABLED3, false)
          commit(types.SET_HRMS15E_DETAIL3_DESC1_DISP, false)
          commit(types.SET_HRMS15E_DETAIL3_DESC2_DISP, false)
        })
    },
    [types.RECEIVED_HRMS15E_DETAIL3_DESC3] ({ commit }, detailParams) {
      hrms15e.getDetailTab3Desc3(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_DETAIL3_DESC3, data)
          if (data.rows.length > 0) {
            commit(types.SET_HRMS15E_DETAIL3_DESC3_SELECTED, data.rows[0])
          } else {
            commit(types.SET_HRMS15E_DETAIL3_DESC3_SELECTED, {})
          }
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          commit(types.SET_HRMS15E_DETAIL3_DESC3_DISABLED, false)
          commit(types.SET_HRMS15E_DETAIL3_DISP, true)
          commit(types.SET_HRMS15E_DETAIL3_DESC3_DISP, false)
          commit(types.SET_HRMS15E_DETAIL3_INFO_DISP, false)
        })
    },
    [types.RECEIVED_HRMS15E_DETAIL3_INFO] ({ commit, state }, detailParams) {
      let defaultData = {
        total: 0,
        rows: []
      }
      defaultData.rows[state.detail3InfoIndexSelected] = {
        kpino: '',
        kpiitem: '',
        target: '',
        achieve: '',
        v_mtrunit: '',
        mtrvalue: '',
        v_mtrvalue: '',
        status: '',
        dtetargt: '',
        kpiwgt: '',
        grdscor: '',
        qtyscor: '',
        table: []
      }
      commit(types.SET_HRMS15E_DETAIL3_INFO, defaultData)
      hrms15e.getDetailTab3Info(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_DETAIL3_INFO, data)
          commit(types.SET_HRMS15E_DETAIL3_INFO_SELECTED, data.rows[state.detail3InfoIndexSelected])
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS15E_DETAIL3_INFO_DESC2_POPUP] ({ commit }, popupParams) {
      hrms15e.getDetailTab3InfoDesc2Popup(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_DETAIL3_INFO_DESC2_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS15E_STATUS_SAVE] ({ state, commit, dispatch }, { searchIndex, saveParams }) {
      hrms15e.postStatusSave({ searchIndex, saveParams })
        .then((response) => {
          const data = JSON.parse(response.request.response)
          dispatch(types.RECEIVED_HRMS15E_INDEX, searchIndex)
          swal({
            title: '', text: data.response, html: true, type: 'success'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          if (data.flg) {
            if (data.flg.toLowerCase() === 'enable') {
              commit(types.SET_HRMS15E_FLG_DISABLED, false)
            }
            if (data.flg.toLowerCase() === 'disable') {
              commit(types.SET_HRMS15E_FLG_DISABLED, true)
            }
          } else {
            if (state.flgDisabled) {
              commit(types.SET_HRMS15E_FLG_DISABLED, true)
            }
          }
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS15E_SENDMAIL] ({ commit, dispatch }, { searchIndex, sendmailParams }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms15e.postSendmail({ searchIndex, sendmailParams })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS15E_INDEX, searchIndex)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS15E_DETAIL1_SAVE] ({ commit, dispatch }, { indexSelected, searchIndex, detail, table }) {
      hrms15e.postDetail1Save({ indexSelected, searchIndex, detail, table })
        .then((response) => {
          const data = JSON.parse(response.request.response)
          dispatch(types.RECEIVED_HRMS15E_INDEX, searchIndex)
          let searchParams = {
            p_codempid: indexSelected.codempid,
            p_dteyreap: searchIndex.year,
            p_numtime: searchIndex.numtime,
            p_numseq: indexSelected.numseq
          }
          dispatch(types.RECEIVED_HRMS15E_SUMSCORE, searchParams)
          swal({
            title: '', text: data.response, html: true, type: 'success'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS15E_DETAIL2_SAVE] ({ commit, dispatch }, { indexSelected, searchIndex, detail, table }) {
      hrms15e.postDetail2Save({ indexSelected, searchIndex, detail, table })
        .then((response) => {
          const data = JSON.parse(response.request.response)
          dispatch(types.RECEIVED_HRMS15E_INDEX, searchIndex)
          let searchParams = {
            p_codempid: indexSelected.codempid,
            p_dteyreap: searchIndex.year,
            p_numtime: searchIndex.numtime,
            p_numseq: indexSelected.numseq
          }
          dispatch(types.RECEIVED_HRMS15E_SUMSCORE, searchParams)
          swal({
            title: '', text: data.response, html: true, type: 'success'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS15E_DELETE] ({ commit, dispatch }, { searchIndex, dataRowsHasFlg }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms15e.postDelete({ searchIndex, dataRowsHasFlg })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                dispatch(types.RECEIVED_HRMS15E_INDEX, searchIndex)
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS15E_DETAIL_COURSE_SAVE] ({ commit, dispatch }, { dataRowsHasFlg, searchIndex, courseParams }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms15e.postDetailCourseSave({ dataRowsHasFlg, searchIndex, courseParams })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS15E_INDEX, searchIndex)
              dispatch(types.RECEIVED_HRMS15E_DETAIL_COURSE, courseParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS15E_DETAIL3_DESC1_SAVE] ({ commit, dispatch }, dataRowsHasFlg) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms15e.postDetail3Desc1Save(dataRowsHasFlg)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS15E_INDEX, {})
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS15E_DETAIL3_INFO_SAVE] ({ commit, dispatch }, { searchIndex, detail3Info, detailParams, indexSelected, toggleTab3InfoBack }) {
      hrms15e.postDetail3InfoSave({ searchIndex, detail3Info })
        .then((response) => {
          const data = JSON.parse(response.request.response)
          dispatch(types.RECEIVED_HRMS15E_INDEX, searchIndex)
          let searchParams = {
            p_codempid: indexSelected.codempid,
            p_dteyreap: searchIndex.year,
            p_numtime: searchIndex.numtime,
            p_numseq: indexSelected.numseq
          }
          dispatch(types.RECEIVED_HRMS15E_SUMSCORE, searchParams)
          dispatch(types.RECEIVED_HRMS15E_DETAIL3_INFO, detailParams)
          dispatch(types.RECEIVED_HRMS15E_DETAIL, detailParams)
          commit(types.SET_HRMS15E_DETAIL3_INFO_INDEX_SELECTED, 0)
          toggleTab3InfoBack()
          swal({
            title: '', text: data.response, html: true, type: 'success'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS15E_SUMSCORE] ({ commit }, searchParams) {
      hrms15e.getSumscore(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS15E_SUMSCORE, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms15e/index.js